import { useEffect } from 'react';
import { $convertToMarkdownString } from '@lexical/markdown';
import { EDITOR_TRANSFORMER } from '../../utils/utils';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
type TextEventHandlerT = ({
  markdown,
  text,
  html
}: {
  markdown: string;
  text: string;
  html: string;
}) => void;
const CustomOnChangePlugin = ({
  onChange
}: {
  onChange: TextEventHandlerT;
}) => {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    return editor.registerUpdateListener(() => {
      const editorState = editor.getEditorState();
      editorState.read(() => {
        const markdown = $convertToMarkdownString(EDITOR_TRANSFORMER).trim();
        const text = (editor.getRootElement()?.textContent?.toString() || '').trim();
        onChange({
          text,
          markdown,
          html: ''
        });
      });
    });
  }, [editor, onChange]);
  return null;
};
export default CustomOnChangePlugin;